import React, { Component } from 'react';
import { DashboardLayout } from '../../layout';
import connect from 'react-redux/es/connect/connect';
import { createSelector } from 'reselect';
import { Link } from 'react-router-dom';
import { alertSelectors } from '../../../common/redux/selectors';
import Skeleton from '@material-ui/lab/Skeleton';
import Rating from '@material-ui/lab/Rating';
import { Pagination } from '@material-ui/lab';
import { itemService, globalService as gs } from '../../../common/services';
import moment from 'moment-timezone';
import TutorBookingMenu from './partials/TutorBookingMenu';
import { defaultActions } from '../../../common/redux/actions';
import { orderStatus } from '../../../helpers';
import TutorBookingItems from './partials/TutorBookingItems';

class TutorBookingList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            bookingItems: null,
            pagination: null,
            loading: false,
        };
    }

    componentDidMount() {
        const { dispatch, config } = this.props;
        (config.config === null) && dispatch(defaultActions.config());
        this.loadBooking();
    }

    loadBooking = (page = 1) => {
        const { dispatch } = this.props;
        this.setState({loading: true});

        itemService.booking("GET", null, {status: orderStatus.ORDER_PENDING, page: page, key: 'bookings' }).then(data => {
            if(data.code) {
                let bookingItems = data.items;
                let pagination = data.pagination;
                this.setState({bookingItems, pagination, loading: false});
            }
        })
        .catch(exception => {
            gs.showErrors(exception, dispatch, alertSelectors);
            this.setState({loading: false});
        });
    }

    onChangePage = (event, page) => {
        this.loadBooking(page);
    }

    render() {
        const { bookingItems, pagination, loading } = this.state;
        //console.log('Book', bookingItems);
        return (<DashboardLayout activeClass="UserBooking">
            <section className="dashboard">
                <div className="row">
                    <TutorBookingMenu activeClass="UserBooking" />
                    
                    <div className="col-12">
                        {(loading) ? <>
                            {[1,2].map((item) =>
                                <div className="post-box mb-4" key={`bok-${item}`}>
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                    <Skeleton variant="text" />
                                </div>
                            )}
                        </> : <>
                            {bookingItems && bookingItems.map(book =>
                                <TutorBookingItems book={book} key={`book-${book.id}`} />
                            )}
                            {(bookingItems && bookingItems.length === 0) && <div className="col-12 py-3 text-left">Booking not found</div>}
                        </>}
                        <div className="d-flex justify-content-center">
                            {pagination && pagination.totalCount > 19 && <>
                                <Pagination count={Math.ceil(parseInt(pagination && pagination.totalCount) / 20)} defaultPage={1} siblingCount={0} size="large" color="primary" onChange={this.onChangePage} />
                            </>}
                        </div>
                    </div>
                    
                </div>

            </section> 
        </DashboardLayout>);
    }
}

const processSelector = createSelector(
    state => state.process,
    process => process
);

const configSelector = createSelector(
    state => state.config,
    config => config
);

const mapStateToProps = createSelector(
    processSelector,
    configSelector,
    (process, config) => ({
        process, config
    })
);

export default connect(mapStateToProps)(TutorBookingList);